import React, { useEffect, useRef, useState } from "react";

export default function Dropdown({ value, options, onChange }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onMouseDown = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onMouseDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const selected = options.find((o) => o.value === value);

  return (
    <div ref={wrapperRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 bg-zinc-900/60 border border-zinc-800 rounded-lg
                   px-3 py-2 text-sm text-zinc-200 cursor-pointer
                   hover:border-zinc-700 focus:outline-none focus:border-zinc-700 transition"
      >
        <span>{selected?.label || ""}</span>
        <span
          className={`text-zinc-500 text-xs transition-transform duration-150
            ${open ? "rotate-180" : ""}`}
        >
          ▾
        </span>
      </button>

      {open && (
        <div
          className="absolute top-full right-0 mt-1.5 min-w-full
                     bg-zinc-900 border border-zinc-800 rounded-lg
                     shadow-xl shadow-black/50 overflow-hidden
                     animate-dropdown-in z-20 py-1"
        >
          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
              className={`w-full text-left px-3 py-1.5 text-sm font-medium transition
                ${
                  opt.value === value
                    ? "bg-emerald-500/15 text-emerald-300"
                    : "text-zinc-300 hover:bg-zinc-800 hover:text-zinc-100"
                }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
